import { supabase } from './supabase';

const MANAGE_TOKEN_TTL_MS = 30 * 24 * 60 * 60 * 1000;

export type ManageTokenSubscriber = {
  id: string | number;
  manage_token?: string | null;
  manage_token_expires_at?: string | null;
};

export function isManageTokenValid(row: ManageTokenSubscriber): boolean {
  return Boolean(
    row.manage_token &&
      row.manage_token_expires_at &&
      new Date(row.manage_token_expires_at).getTime() > Date.now(),
  );
}

/** Reuse a valid manage_token or mint a fresh one (same rules as email sends). */
export async function ensureSubscriberManageToken(
  row: ManageTokenSubscriber,
): Promise<string> {
  if (isManageTokenValid(row)) return row.manage_token!.trim();

  const token = crypto.randomUUID();
  const expiresAt = new Date(Date.now() + MANAGE_TOKEN_TTL_MS).toISOString();
  const { error } = await supabase
    .from('subscribers')
    .update({
      manage_token: token,
      manage_token_expires_at: expiresAt,
      updated_at: new Date().toISOString(),
    })
    .eq('id', row.id as string | number);

  if (error) throw error;
  return token;
}
